import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { IndividualActivationStepEnum } from '../../lib/enums';
import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { checkIndividualActivationStep } from '../../lib/store/selectors';
import { isMyPortalTrade } from '../../lib/util/auth/helpers';
import { VerifyIdentityStatus } from '../../lib/util/types';

import { UI_ROUTES } from '../../util/routes';

type Props = {
  className?: string;
} & ReduxProps;

const SymbolDetailsNotActiveBox = ({ className, activationStep, accounts }: Props) => {
  const [title, setTitle] = useState<string>('');
  const [activateAccountFinished, setActivateAccountFinished] = useState<boolean>(true);
  const [verifyIdentityStatus, setVerifyIdentityStatus] = useState<VerifyIdentityStatus>(
    { finished: false, disabled: false, pending: false },
  );
  const [firstDepositDisabled, setFirstDepositDisabled] = useState<boolean>(true);

  useEffect(() => {
    switch (activationStep) {
      case IndividualActivationStepEnum.InEnrollment:
        setActivateAccountFinished(false);
        setVerifyIdentityStatus(prevState => ({ ...prevState, disabled: true }));
        setTitle(lang.commonNextStepsTitleVerification()); break;
      case IndividualActivationStepEnum.InVerification:
        setTitle(lang.commonNextStepsTitleVerification());
        break;
      case IndividualActivationStepEnum.InPendingVerification:
        setTitle(lang.commonNextStepsTitleVerification());
        setVerifyIdentityStatus(prevState => ({ ...prevState, pending: true }));
        break;
      case IndividualActivationStepEnum.Activated:
        setTitle(lang.commonNextStepsTitleActive());
        setFirstDepositDisabled(false);
        if (isMyPortalTrade() && accounts.length === 0) {
          setVerifyIdentityStatus(prevState => ({ ...prevState, pending: true }));
          setFirstDepositDisabled(true);
        } else {
          setVerifyIdentityStatus(prevState => ({ ...prevState, finished: true }));
        }
        break;
      default: break;
    }
  }, [activationStep, accounts]);

  const getFundsRedirectPath = ():string => {
    if (isMyPortalTrade()) {
      return UI_ROUTES.funds;
    }
    return UI_ROUTES.funds + UI_ROUTES.makeYourFirstDeposit;
  };

  return <></>;// No activation steps in capital
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
  accounts: state.crm.accounts,
  activationStep: checkIndividualActivationStep(
    state.crm.individualExtendedInfo,
    state.crm.enroll.financialQuestionnaireSections,
    state.auth.isAppropriatenessPopupConfirmed,
  ),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SymbolDetailsNotActiveBox);
